import Stickyfill from 'stickyfilljs';
import {
  BackgroundVideo,
  Collapse,
  helpers,
  Modal,
  Panel,
  phoneField,
  slider,
  VideoPlayer,
} from '@phx-styleguides/iwc';

import {
  addLoadingState as phxsgAddLoadingState,
  removeLoadingState as phxsgRemoveLoadingState,
} from '@sg/resources/assets/js/helpers/buttons';

import { AnimateGroupReveal, AnimateReveal } from '@sg-core/resources/assets/js/animations';
import { PhxsgToaster } from '@sg/src/View/Components/Atoms/Toaster';
import { CardExpandable } from '@sg/src/View/Components/Molecules/Card/card-expandable';

const patchedHelpers = {
  ...helpers,
  buttons: {
    ...helpers.buttons,
    addLoadingState: phxsgAddLoadingState,
    removeLoadingState: phxsgRemoveLoadingState,
  },
};

export {
  AnimateGroupReveal,
  AnimateReveal,
  BackgroundVideo,
  CardExpandable,
  Collapse,
  Modal,
  Panel,
  patchedHelpers as helpers,
  phoneField,
  PhxsgToaster as PhxToaster,
  slider,
  Stickyfill,
  VideoPlayer,
};
